import Loadable from "react-loadable";

const LazyProfileCandidate = Loadable({
  loader: () => import(/* webpackChunkName: 'profile-candidates' */ "./index"),
  loading: () => 'loading...'
});

export default LazyProfileCandidate;
